import { motion } from 'motion/react';

import styles from './NoizeScale.module.css';

import { useEffect, useRef } from 'react';

export const NoizeScale = ({
  noiseLevel = 75,
  maxNoiseLevel = 100,
  remSize,
}) => {
  const canvasRef = useRef(null);

  const value1 = Math.round(maxNoiseLevel * 0.05);
  const value2 = Math.round(maxNoiseLevel * 0.35);
  const value3 = Math.round(maxNoiseLevel * 0.65);
  const value4 = Math.round(maxNoiseLevel * 0.95);

  const text = `• • • ${value4} • • • • • • • • • • • • • • • • • • ${value3} • • • • • • • • • • • • • • • • • • ${value2} • • • • • • • • • • • • • • • • • • ${value1} • • •`;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const chars = text.split('');

    const getFontForChar = (char) => {
      if (char === '•') {
        return `bold ${2 * remSize}px Arial`;
      } else {
        return `bold ${3.3 * remSize}px Arial`;
      }
    };

    let totalWidth = 0;
    const charWidths = [];
    const charFonts = [];

    chars.forEach((char) => {
      const font = getFontForChar(char);
      ctx.font = font;
      const width = ctx.measureText(char).width;
      charWidths.push(width);
      charFonts.push(font);
      totalWidth += width;
    });

    const textHeight = 50;
    canvas.width = totalWidth;
    canvas.height = textHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const gradientPercent = (noiseLevel / maxNoiseLevel) * 100;
    const gradientWidth = (totalWidth * gradientPercent) / 100;
    const gradientStartX = totalWidth - gradientWidth;

    const gradient = ctx.createLinearGradient(0, 0, totalWidth, 0);
    gradient.addColorStop(0, '#ffefff');
    gradient.addColorStop(0.33, '#ab42ff');
    gradient.addColorStop(0.66, '#6334ff');
    gradient.addColorStop(1, '#2230ff');

    ctx.save();
    ctx.beginPath();
    ctx.rect(gradientStartX, 0, gradientWidth, textHeight);
    ctx.clip();

    let x = 0;
    chars.forEach((char, i) => {
      ctx.font = charFonts[i];
      ctx.fillStyle = gradient;

      if (char === '•') {
        ctx.fillText(char, x, 28);
      } else {
        ctx.fillText(char, x, 32);
      }

      x += charWidths[i];
    });
    ctx.restore();

    ctx.save();
    ctx.beginPath();
    ctx.rect(0, 0, gradientStartX, textHeight);
    ctx.clip();

    x = 0;
    chars.forEach((char, i) => {
      ctx.font = charFonts[i];
      ctx.fillStyle = 'white';

      if (char === '•') {
        ctx.fillText(char, x, 28);
      } else {
        ctx.fillText(char, x, 32);
      }

      x += charWidths[i];
    });
    ctx.restore();
  }, [text, noiseLevel, maxNoiseLevel, remSize]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      exit={{ opacity: 0 }}
      className={styles.noizeScale}
    >
      <canvas ref={canvasRef} />
    </motion.div>
  );
};
